import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';

interface DisputeStatusBannerProps {
  className?: string;
}

export const DisputeStatusBanner: React.FC<DisputeStatusBannerProps> = ({ className }) => {
  return (
    <Alert className={`border-orange-500 bg-orange-50 ${className || ''}`}>
      <AlertTriangle className="h-5 w-5 text-orange-600" />
      <AlertTitle className="text-orange-900 font-semibold">Dispute in Progress</AlertTitle>
      <AlertDescription className="text-orange-800">
        This job has an active dispute under administrator review. Payment processing 
        is paused until the dispute is resolved. Both parties will be contacted for 
        additional information as needed.
      </AlertDescription>
    </Alert>
  );
};
